import PermissionsManagement from './PermissionsManagement';

export default PermissionsManagement; 